import { isChild } from '../utils/helper.functions';
import { Title } from './title';

export interface Insurant {
    id?: number;
    title?: Title;
    firstName: string;
    lastName: string;
    dateOfBirth: string;
    isInsuree: boolean;
    isChild: boolean;
    insuranceRankId?: number;
    category?: string;
    missingTeeth?: number;
    healthInsurance?: string;
}

export const isInsurant = (x: unknown): x is Insurant =>
    typeof x === 'object' &&
    'firstName' in x &&
    typeof x.firstName === 'string' &&
    'lastName' in x &&
    typeof x.lastName === 'string' &&
    'dateOfBirth' in x &&
    typeof x.dateOfBirth === 'string';

export const isArrayOfInsurants = (x: unknown): x is Insurant[] =>
    Array.isArray(x) && x.every((item: unknown) => isInsurant(item));

export const createInsurant = (options: Partial<Insurant> = {}): Insurant => ({
    id: options?.id ?? undefined,
    title: options?.title ?? null,
    firstName: options?.firstName ?? '',
    lastName: options?.lastName ?? '',
    dateOfBirth: options?.dateOfBirth ?? '',
    isInsuree: options?.isInsuree ?? options?.category === 'insuree',
    isChild: options?.isChild ?? (options?.dateOfBirth ? isChild(options.dateOfBirth) : false),
    insuranceRankId: options?.insuranceRankId ?? null,
    category: options?.category ?? 'insurants',
    missingTeeth: options?.missingTeeth ?? null,
    healthInsurance: options?.healthInsurance ?? null,
});

export interface InsurantDto {
    Id?: number;
    TitleId?: number | null;
    Title?: string | null;
    Firstname: string;
    Lastname: string;
    DateOfBirth: string;
    IsInsuree: boolean;
    InsuranceRankId: number | null;
    MissingTeeth: number | null;
    HealthInsurance: string | null;
}

export function insurantToDto(insurant: Insurant): InsurantDto {
    return {
        Id: insurant.id,
        TitleId: insurant.title?.id ?? null,
        Firstname: insurant.firstName,
        Lastname: insurant.lastName,
        DateOfBirth: insurant.dateOfBirth,
        IsInsuree: insurant.isInsuree,
        InsuranceRankId: insurant.insuranceRankId ?? null,
        MissingTeeth: insurant.missingTeeth ?? null,
        HealthInsurance: insurant.healthInsurance ?? null,
    };
}

export function insurantFromDto(dto: InsurantDto): Insurant {
    return {
        id: dto.Id,
        title: dto.Title && dto.TitleId ? { id: dto.TitleId, description: dto.Title } : undefined,
        firstName: dto.Firstname,
        lastName: dto.Lastname,
        dateOfBirth: dto.DateOfBirth,
        isInsuree: dto.IsInsuree,
        isChild: dto.DateOfBirth ? isChild(dto.DateOfBirth) : false,
        insuranceRankId: dto.InsuranceRankId,
        category: undefined,
        missingTeeth: dto.MissingTeeth,
        healthInsurance: dto.HealthInsurance,
    };
}
